/**
 * Les banques depuis lesquelles Gertrude sait produire un fichier de virements.
 *
 * Module PUR, importé aussi par le frontend : la liste vivait en huit copies
 * (trois routes, quatre écrans, un script), et ajouter QONTO aurait demandé de
 * n'en oublier aucune. Ce n'est pas la liste des banques de `reference-data.ts` :
 * celle-ci porte aussi LCL, d'où l'on ne fait aucun virement.
 */
export const BANQUES_VIREMENT = ['BNP', 'CIC', 'QONTO'] as const;

export type BankCode = (typeof BANQUES_VIREMENT)[number];

export function estBanqueVirement(valeur: unknown): valeur is BankCode {
  return typeof valeur === 'string' && (BANQUES_VIREMENT as readonly string[]).includes(valeur);
}

/**
 * La banque d'une facture ou d'un avoir Books (champ « Banque », saisi à la
 * main, donc « CIC Kestio », « bnp »…), ou null : la ligne arrive alors sans
 * banque dans « À payer », et c'est à la préparation de la choisir. Une banque
 * d'où l'on ne vire pas (LCL) rend null, jamais une banque voisine.
 */
export function normaliserBanque(cf: unknown): BankCode | null {
  const s = String(cf ?? '').toUpperCase();
  return BANQUES_VIREMENT.find((b) => s.includes(b)) ?? null;
}
